import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { Text } from 'ds/components/typography';

export const Wrapper = styled.div`
  max-width: 448px;
  padding: 0 ${({ theme }) => theme.spacing(3)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: 0 auto;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    align-items: flex-start;
    width: 100%;
    max-width: auto;
    padding: 0 ${theme.spacing(5)};
  `}
`;

export const Title = styled.div`
  font-size: 25px;
  line-height: 32px;
  font-weight: 700;
  text-align: center;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    max-width: 260px;
    `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    text-align: right;
    font-size: 32px;
    line-height:42px;
    font-weight: 500;
    text-align: right;
    max-width: 310px;
    margin-left: auto;
    margin-top: ${theme.spacing(1)};
  `}
`;

export const Subtitle = styled(Text)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    text-align: right;
    max-width: 280px;
  `}
`;

export const WelcomeButton = styled(Button)`
  font-weight: 700;
`;
